import * as types from '../types';

const INITIAL_STATE = {
  warnings: {},
  descriptions: {},
  manuals: {},
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.WARNING_FETCHED: {
      const { id, lang, data } = action.payload;

      return {
        ...state,
        warnings: {
          ...state.warnings,
          [id]: {
            ...(state.warnings[id] || {}),
            [lang]: data,
          },
        },
      };
    }
    case types.DESCRIPTION_FETCHED: {
      const { id, lang, data } = action.payload;

      return {
        ...state,
        descriptions: {
          ...state.descriptions,
          [id]: {
            ...(state.descriptions[id] || {}),
            [lang]: data,
          },
        },
      };
    }
    case types.MANUAL_FETCHED: {
      const { id, lang, data } = action.payload;

      return {
        ...state,
        manuals: {
          ...state.manuals,
          [id]: {
            ...(state.manuals[id] || {}),
            [lang]: data,
          },
        },
      };
    }
    default:
      return state;
  }
}
